module.exports = "/_next/static/images/009231d0334c342fc15657aeb2693879-phone-lg.png.webp";